


import React from "react";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  Box,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";

const CustomDialog = ({
  open,
  message,
  onClose,
  title = "Notification",
  buttonText = "OK",
  type = "info", // 'error', 'warning', 'success', 'info'
  secondaryButtonText = null,
  onSecondaryAction = null,
}) => {

  const getIconAndColor = () => {
    switch (type) {
      case "error":
        return {
          icon: <ErrorOutlineIcon sx={{ fontSize: 50, color: "#ff4d4f" }} />,
          bgColor: "#ffebee",
        };
      case "warning":
        return {
          icon: <WarningAmberIcon sx={{ fontSize: 50, color: "#ff9800" }} />,
          bgColor: "#fff3e0",
        };
      case "success":
        return {
          icon: <CheckCircleOutlineIcon sx={{ fontSize: 50,}} />,
          bgColor: "#006D77",
        };
      default: 
        return {
          icon: <ErrorOutlineIcon sx={{ fontSize: 50, color: "#006D77" }} />,
          bgColor: "#006D77",
        };
    }
  };
  
  const { icon, bgColor, iconBgColor } = getIconAndColor();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: "12px",
          p: 2,
        },
      }}
    >
      {/* Close Button */}
      <IconButton
        onClick={onClose}
        sx={{
          position: "absolute",
          right: 8,
          top: 8,
          color: "#666",
        }}
      >
        <CloseIcon />
      </IconButton>

      <DialogContent sx={{ textAlign: "center", pt: 2, pb: 1 }}>
        {/* Icon Circle */}
        <Box
          sx={{
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            width: 50,
            height: 50,
            borderRadius: "50%",
            backgroundColor: `${bgColor}1A`,
            color: "white",
            mb: 2,
          }}
        >
          {icon}
        </Box>

        {/* Title */}
        <Typography
          variant="h6"
          sx={{
            fontWeight: 600,
            color: "#262626",
            mb: 1.5,
            fontSize: "18px",
          }}
        >
          {title}
        </Typography>

        {/* Message */}
        <Typography
          sx={{
            whiteSpace: "pre-line",
            color: "#8c8c8c",
            fontSize: "14px",
            lineHeight: 1.6,
          }}
        >
          {message}
        </Typography>
      </DialogContent>

      <DialogActions
        sx={{
          justifyContent: "center",
          pb: 2,
          px: 3,
          gap: 1,
        }}
      >
        {/* Secondary Button (if provided) */}
        {secondaryButtonText && onSecondaryAction && (
          <Button
            onClick={onSecondaryAction}
            variant="outlined"
            sx={{
              textTransform: "none",
              borderRadius: "6px",
              px: 3,
              py: 1,
              borderColor: "#d9d9d9",
              color: "#595959",
              "&:hover": {
                borderColor: "#40a9ff",
                backgroundColor: "#006D77",
              },
            }}
          >
            {secondaryButtonText}
          </Button>
        )}

        {/* Primary Button */}
        <Button
          onClick={onClose}
          variant="contained"
          sx={{
            backgroundColor:"#006D77",
            "&:hover": { backgroundColor: "#40a9ff" },
            color: "#fff",
            textTransform: "none",
            borderRadius: "6px",
            px: 3,
            py: 1,
            minWidth: secondaryButtonText ? "auto" : "120px",
          }}
        >
          {buttonText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CustomDialog;